import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var WordShortcutSvg = function WordShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#185ABD",
    fillRule: "evenodd",
    d: "M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H8.708A9 9 0 0 0 0 9.223V2a2 2 0 0 1 2-2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.088 9.065v-.572h.034l.602.001.288.001.296.002c.195 0 .381.003.53.005 2.285.043 3.297 1.123 3.37 2.983a9 9 0 0 0-1.4-1.095c-.35-.705-1.044-.992-1.992-.992h-.163a9 9 0 0 0-1.565-.333m7.24 5.519c.463.33 1.046.506 1.724.506 1.786 0 2.898-1.246 2.898-3.33 0-2.106-1.125-3.357-2.898-3.357-1.778 0-2.925 1.256-2.925 3.357q0 .44.065.828c.46.61.843 1.28 1.137 1.996m0-2.81c0 1.683.666 2.398 1.724 2.398 1.066 0 1.705-.715 1.705-2.398 0-1.71-.648-2.453-1.705-2.453-1.058 0-1.724.747-1.724 2.453m10.917 1.066c-.148 1.184-.86 2.25-2.565 2.25-1.79 0-2.866-1.3-2.866-3.384 0-2.079 1.066-3.303 2.866-3.303 1.422 0 2.44.963 2.565 2.178H20.09c-.13-.715-.617-1.26-1.44-1.26-1.035 0-1.625.702-1.625 2.399 0 1.71.59 2.452 1.625 2.452.823 0 1.31-.612 1.44-1.332z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var WordShortcut = function WordShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: WordShortcutSvg
  }));
};